import { PlusCircleOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client/react';
import { App, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import type React from 'react';
import type { SpecialRateCreateInput } from '../../../../graphql/generated/graphql.ts';
import type { SpecialRate } from '../SpecialRates.tsx';
import { CREATE_SPECIAL_RATE_MUTATION } from './CreateSpecialRateModal.gql';
import { SpecialRateForm } from './SpecialRateForm';

export const CreateSpecialRateModal: React.FC<{
  labId: string;
  specialRates: SpecialRate[];
  modalVisible: boolean;
  onClose: () => void;
  onSuccess: () => void;
}> = ({ labId, specialRates, modalVisible, onClose, onSuccess }) => {
  const [createSpecialRateMutation, { loading }] = useMutation(CREATE_SPECIAL_RATE_MUTATION);
  const [form] = useForm<SpecialRateCreateInput>();
  const { message } = App.useApp();

  const create = async (values: SpecialRateCreateInput) => {
    try {
      await createSpecialRateMutation({
        variables: {
          input: {
            ...values,
            labId: labId,
          },
        },
      });

      message.success('Sondertarif wurde erstellt');
      onSuccess();
      closeAndReset();
    } catch (_e) {
      message.error('Sondertarif konnte nicht erstellt werden');
    }
  };

  const closeAndReset = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      width={768}
      title="Neuen Sondertarif erstellen"
      okText="Erstellen"
      okButtonProps={{ icon: <PlusCircleOutlined /> }}
      open={modalVisible}
      onCancel={closeAndReset}
      onOk={form.submit}
      confirmLoading={loading}
      destroyOnHidden
    >
      <SpecialRateForm
        form={form}
        initialValues={{
          labId: labId,
          name: '',
          shortName: '',
          code: '',
        }}
        codeValidator={code => specialRates.length === 0 || !specialRates.some(i => i.code === code)}
        onFinish={values => create(values as SpecialRateCreateInput)}
      />
    </Modal>
  );
};
